import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { CountryModel } from '@/app/models/timesheet/countryModel'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'

type Props = {
  companyId: string
}

/**
 * Fetches countries for export (business trips)
 */
export function useQueryExportCountries({ companyId }: Props) {
  return useQuery<CountryModel[]>({
    queryKey: ['exportCountries', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`api/${companyId}/country/countries`)
      return data || []
    },
    staleTime: MINUTE_IN_MS * 60, // cache for 60 minutes
    enabled: !!companyId,
  })
}

